import { useSelector } from 'react-redux';

import getEmailSubscribeStatus from 'Helpers/CRM/email-subscribe-status';

/**
 * Custom hook to get the email subscribe status of the current user.
 * This hook subscribes to the auth slice of the Redux store and returns the user's email subscribe status.
 *
 * @returns {import('Helpers/CRM/email-subscribe-status').EmailSubscribeStatus}
 */
const useEmailSubscribeStatus = () => {
  const auth = useSelector(state => state?.auth);

  return getEmailSubscribeStatus(auth);
};

export default useEmailSubscribeStatus;
